/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import LoadingButton from '@mui/lab/LoadingButton';
import { useGenerateSummary } from './useHooks';

export const GenerateSummaryButton = ({ documentVersionId }: { documentVersionId?: string }) => {
  const { isFetchingSummary, isDisabled, summaryButtonHandler, showRegenerateSummary } = useGenerateSummary({
    documentVersionId,
  });

  return (
    <LoadingButton
      variant="custom"
      color="secondary"
      loading={isFetchingSummary}
      onClick={summaryButtonHandler}
      disabled={isDisabled || false}
      data-testid="generate-summary-button"
      sx={{ width: '100px' }}
    >
      {showRegenerateSummary ? 'Regenerate' : 'Generate'}
    </LoadingButton>
  );
};
